import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import CustomDrawer from '../../../../../shared/CustomDrawer/CustomDrawer';
import zeplinColor from '../../../../../../theme/Color';
import { UserForm } from '../UserForm/UserForm';

interface AddUserDrawerProps {
  open: boolean;
  onClose: () => void;
  onAddSuccess?: (operation: 'add' | 'edit') => void;
  mode?: 'add' | 'edit';
  userData?: {
    id?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    mobile?: string;
    roleId?: string;
    profileImage?: string;
  };
}

const AddUserDrawer: React.FC<AddUserDrawerProps> = ({
  open,
  onClose,
  onAddSuccess,
  mode = 'add',
  userData,
}) => {
  const handleClose = (isOpen: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    onClose();
  };

  return (
    <CustomDrawer state={open} onClose={handleClose(false)}>
      <Box sx={{ width: { xs: '427px', xl: '527px' }, position: 'relative', overflowY: 'auto' }}>
        {/* Header */}
        <Box
          sx={{ position: 'sticky', top: 0, backgroundColor: zeplinColor.Neutral1, zIndex: '1' }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: { xs: '30px 20px 20px 20px', xl: '40px 24px 24px 24px' },
            }}
          >
            <Typography variant='responsiveHeading2' color={zeplinColor.BasicBlack}>
              {mode === 'edit' ? 'Edit User' : 'Add New User'}
            </Typography>
            <img
              src={'/assets/close-icon.svg'}
              alt='close'
              style={{ cursor: 'pointer', width: '24px', height: '24px' }}
              onClick={handleClose(false)}
            />
          </Box>
          <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5 }} />
        </Box>

        {/* Content */}

        <UserForm
          handleToggleDrawer={onClose}
          onAddSuccess={() => {
            onAddSuccess?.(mode);
            onClose();
          }}
          mode={mode}
          initialData={userData}
        />
      </Box>
    </CustomDrawer>
  );
};

export default AddUserDrawer;
